<script>
import Icon from '../../Icon/Icon.vue';

export default {
  components: { Icon },
  props: {
    questionData: {
      type: Object,
      default: () => {},
    },
    answer: {
      type: Number,
      default: null,
    },
  },
  methods: {
    handleAnswerChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<template>
  <div class="cxm-Thumbs">
    <div
      class="cxm-Thumb -down"
      :class="{'-selected': answer === 0 }"
    >
      <Icon
        name="thumbs-down"
        :size="48"
        :handle-click="() => handleAnswerChange(0)"
      />
    </div>
    <div
      class="cxm-Thumb -up"
      :class="{'-selected': answer === 1 }"
    >
      <Icon
        name="thumbs-up"
        :size="48"
        :handle-click="() => handleAnswerChange(1)"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cxm-Thumbs {
  display: flex;
  align-items: center;
  gap: var(--track-spacing-sm);
}
.cxm-Thumb {
  &:hover {
    cursor: pointer;
  }
  &.-down {
    svg {
      stroke: var(--track-color-bluegray-60);
    }
    &:hover {
      svg {
        stroke: var(--track-color-metric-0);
      }
    }
    &.-selected {
      svg {
        fill: var(--track-color-metric-0);
        stroke: var(--track-color-white);
      }
      &::v-deep svg > rect {
        stroke: var(--track-color-metric-0);
      }
    }
  }
  &.-up {
    svg {
      stroke: var(--track-color-bluegray-60);
    }
    &:hover {
      svg {
        stroke: var(--track-color-metric-10);
      }
    }
    &.-selected {
      svg {
        fill: var(--track-color-metric-10);
        stroke: var(--track-color-white);
      }
      &::v-deep svg > rect {
        stroke: var(--track-color-metric-10);
      }
    }
  }
}
</style>
